/* Timeline steps light up as they scroll into view, and the connecting line
   fills behind them. Progressive enhancement: without JS every step simply
   renders in its finished state (see .tt-step defaults in tt-brand.css). */
(function () {
  var SELECTOR = '.tt-timeline';

  function activate(root) {
    var steps = root.querySelectorAll('.tt-step');
    if (!steps.length) return;

    // Only dim them once JS is confirmed running, so a no-JS visitor
    // never sees a permanently greyed-out timeline.
    root.classList.add('tt-timeline--animated');

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      steps.forEach(function (s) { s.classList.add('is-active'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-active');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -22% 0px', threshold: 0.35 });

    steps.forEach(function (s) { io.observe(s); });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(activate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
